import { booleanAttribute, Component, input, TemplateRef, viewChild } from '@angular/core';

@Component({
  selector: 'app-tab',
  template: '<ng-template><ng-content /></ng-template>',
})
export class TabComponent<V extends string = string> {
  value = input.required<V>();

  label = input.required<string>();

  disabled = input(false, { transform: booleanAttribute });

  content = viewChild.required(TemplateRef);
}
